// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css'
import 'styles/reset.css'
import 'styles/iconfont.css'
import 'styles/common.css'
import 'styles/animate.min.css'
import ElementUI from 'element-ui'
import axios from 'axios'
import 'babel-polyfill'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import '../node_modules/swiper/css/swiper.css'
import store from './store'
import * as loginAuthentication from './util/loginAuthentication'
Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.use(ElementUI)
Vue.use(VueAwesomeSwiper)
Vue.prototype.$loginAuthentication = loginAuthentication
/* eslint-disable no-new */
// 路由跳转后，页面回到顶部
router.afterEach(() => {
  document.body.scrollTop = 0
  document.documentElement.scrollTop = 0
})
if (process.env.VUE_APP_ENV === 'online') {
  // eslint-disable-next-line
  var _hmt = _hmt || [];
  window._hmt = _hmt;// 修改为window 全局变量
  (function () {
    var hm = document.createElement('script')
    var s = document.getElementsByTagName('script')[0]
    hm.src = 'https://hm.baidu.com/hm.js?dbf5050d0b0d3c6ed8632cd407683406'
    s.parentNode.insertBefore(hm, s)
  })()
}
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js